import { Size } from '@flyblack/common/constants';

const allSizes = Object.values(Size);

export const getStylesWithSize = (className: (size: Size) => string, valid: (size: Size) => boolean) =>
  allSizes.reduce((data, size) => ({ ...data, [className(size)]: valid(size) }), {});
